import React, { useEffect, useState, useSyncExternalStore } from "react";
import kartSvg from "../assets/images/group0.svg";
import user from "../assets/images/group1.svg";
import logo from "../assets/images/logo/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import LoginPopup from "../components/LoginPopup";
import { useSelector } from "react-redux";



const Navbar = ({ gradient = false }) => {
  const [modal, setModal] = useState({ open: false });
  const isLoggedIn = useSelector( state => state.auth.isLoggedIn )
  const navigate = useNavigate()


  const isStickySync = useSyncExternalStore(
    (listner) => {
      window.addEventListener('scroll', listner)
      return () => { window.removeEventListener('scroll', listner) }
    },
    () => window.scrollY > 50
  )

  const handleLogin = () => {
    if( isLoggedIn ){
      navigate('/user/profile')
      return
    }
    setModal({ open: true })
  }

  return (
    <>
      <div
        className={`navbar row mx-0 text-light fw-bold ${ gradient && "navbar-gradient" } ${isStickySync && 'navbar-gradient'} `}   >
        <div className="col-2 d-flex justify-content-center align-items-center">
          <Link to={"/"}>
            <img className="logo" src={logo} alt="" />
          </Link>
        </div>
        <div className="col-8 ">
          <ul className="list-unstyled d-flex gap-4 py-3 align-items-center justify-content-center m-0">
            <li>
              <NavLink className={"pb-2"} to={"/accomodation"}>Accommodation</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/guide"}>Guide</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/live-darshan"}>Live Darshan</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/e-puja"}>E-Puja</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/tours-events"}>Tours & Events</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/products"}>E-commerce</NavLink>
            </li>
            <li>
              <NavLink className={"pb-2"} to={"/blogs"}>Blogs</NavLink>
            </li>
          </ul>
        </div>
        <div className="col-2">
          <ul className="list-unstyled d-flex justify-content-center align-items-center m-0 gap-3">
            <li>
              <Link
                to={"/cart"}
                className="p-2 d-flex justify-content-center align-items-center"
                style={{
                  background: "#F9EBD7",
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                }}
              >
                <img src={kartSvg} alt="" className="w-100 h-100 " />
              </Link>
            </li>
            <li>
              <div
                className="p-2 d-flex justify-content-center align-items-center cursor-pointer"
                style={{
                  background: "#F9EBD7",
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                }}
                onClick={handleLogin}
              >
                <img src={user} alt="" className="w-100 h-100 " />
              </div>
            </li>
          </ul>
        </div>
      </div>

      {modal.open && <LoginPopup open={modal.open} setOpen={setModal} />}
    </>
  );
};

export default Navbar;
